export default [
  {
    title: 'breadcrumb.chat',
    route: 'chat',
    icon: 'MessageSquareIcon',
    resource: 'chat',
    action: 'read',
  },
];